// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "music_upload".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "music_upload" table (1:1 with a DB row, on the wire). */
export const musicUploadAtomSchema = z.object({
    id: z.string(),
    name: z.string(),
    blobUrl: z.string(),
    durationSec: z.number().nullable(),
    startSec: z.number().nullable(),
    organizationId: z.string(),
    uploadedById: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=musicUpload.js.map